// extracted by mini-css-extract-plugin
module.exports = {"debtWrapper":"PatientSelectUI_debtWrapper__11SDC","debt":"PatientSelectUI_debt__3r1Cm"};